export const DONE_BUTTON_TEXT = "Done";
export const DESKTOP_CALENDAR_TITLE_ROUND_TRIP =
  "Select the arrival and departure dates for your flight";
export const DESKTOP_CALENDAR_TITLE_ONE_WAY =
  "Select your departure date for your flight";
